export default __webpack_public_path__ + "static/media/new-logo.7bb8e4db.svg";